var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "#DE0043",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.33463L15.3333 4.0013L12 0.667969V2.66797H9.33333V5.33464H12V7.33463ZM13.3333 10.3346C12.5 10.3346 11.7 10.2013 10.9533 9.95463C10.72 9.8813 10.46 9.93464 10.2733 10.1146L8.80667 11.5813C6.92 10.6213 5.37333 9.0813 4.41333 7.18797L5.88 5.71463C6.06667 5.5413 6.12 5.2813 6.04667 5.04797C5.8 4.3013 5.66667 3.5013 5.66667 2.66797C5.66667 2.3013 5.36667 2.0013 5 2.0013H2.66667C2.3 2.0013 2 2.3013 2 2.66797C2 8.92797 7.07333 14.0013 13.3333 14.0013C13.7 14.0013 14 13.7013 14 13.3346V11.0013C14 10.6346 13.7 10.3346 13.3333 10.3346Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardCall);
export default __webpack_public_path__ + "static/media/forward-call.2f266160eab8faa027e68495912576ad.svg";
export { ForwardRef as ReactComponent };